"use client";
import React from "react";
import Siderail from "@/components/SideRail";
import CollapsedContent from "./SideRailContent/CollapsedContent";
import FullSizeContent from "./SideRailContent/FullSizeContent";
import { ProgramHeroSideRailContainerProps } from "./SideRailContent/types";
import useSideRailComponentList from "./SideRailContent/useSideRailComponentList";

export default function ProgramHeroSideRailContainer({
  programData,
  courses,
  pricingData,
  skus,
  programIsEnrollable,
}: ProgramHeroSideRailContainerProps) {
  const componentList = useSideRailComponentList({
    programData,
    courses,
    pricingData,
    skus,
    programIsEnrollable,
  });

  return (
    <Siderail
      className="shadow-hero-rail w-[430px] rounded-xl"
      stickyTriggerSelector="#program-details-body-container"
      stickyStopSelector="#program-category-cta"
      initialRight={-40}
      collapsedContent={<CollapsedContent componentList={componentList} />}
    >
      <FullSizeContent componentList={componentList} />
    </Siderail>
  );
}
